"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_groups_search_1 = __importDefault(require("../constants/actions/remote-groups-search"));

var api_1 = __importDefault(require("../api"));

function search(searchText) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _ref2, list, last_item_marker;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: remote_groups_search_1.default.SEARCH_INIT,
                  search_text: searchText
                });
                _context.prev = 1;
                _context.next = 4;
                return api_1.default.Groups.search(searchText, null);

              case 4:
                _ref2 = _context.sent;
                list = _ref2.list;
                last_item_marker = _ref2.last_item_marker;
                dispatch({
                  type: remote_groups_search_1.default.SEARCH_SUCCESS,
                  list: list,
                  last_item_marker: last_item_marker
                });
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);
                dispatch({
                  type: remote_groups_search_1.default.SEARCH_FAILURE,
                  error: _context.t0
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

exports.search = search;

function fetchPopular(isReload) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var curList, list;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                curList = getState().remoteGroupsSearch.popular;

                if (!(curList.length > 0 && isReload === false)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                dispatch({
                  type: remote_groups_search_1.default.FETCH_POPULAR_INIT
                });
                _context2.prev = 4;
                _context2.next = 7;
                return api_1.default.Groups.fetchPopular();

              case 7:
                list = _context2.sent;
                dispatch({
                  type: remote_groups_search_1.default.FETCH_POPULAR_SUCCESS,
                  popular: list
                });
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                dispatch({
                  type: remote_groups_search_1.default.FETCH_POPULAR_FAILURE,
                  error: _context2.t0
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 11]]);
      }));

      return function (_x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
}

exports.fetchPopular = fetchPopular;

function reload() {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var remoteGroupsSearchState, oldSearchText, _ref5, list, last_item_marker;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch({
                  type: remote_groups_search_1.default.RELOAD_INIT
                });
                remoteGroupsSearchState = getState().remoteGroupsSearch;
                oldSearchText = remoteGroupsSearchState.search_text;
                _context3.prev = 3;
                _context3.next = 6;
                return api_1.default.Groups.search(oldSearchText, null);

              case 6:
                _ref5 = _context3.sent;
                list = _ref5.list;
                last_item_marker = _ref5.last_item_marker;
                dispatch({
                  type: remote_groups_search_1.default.RELOAD_SUCCESS,
                  list: list,
                  last_item_marker: last_item_marker
                });
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](3);
                dispatch({
                  type: remote_groups_search_1.default.RELOAD_FAILURE,
                  error: _context3.t0
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 12]]);
      }));

      return function (_x5, _x6) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
}

exports.reload = reload;

function fetchMore() {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch, getState) {
        var remoteGroupsSearchState, oldList, oldSearchText, oldLastItemMarker, _ref7, nextList, last_item_marker, list;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch({
                  type: remote_groups_search_1.default.FETCH_MORE_INIT
                });
                remoteGroupsSearchState = getState().remoteGroupsSearch;
                oldList = remoteGroupsSearchState.list, oldSearchText = remoteGroupsSearchState.search_text, oldLastItemMarker = remoteGroupsSearchState.last_item_marker;
                _context4.prev = 3;
                _context4.next = 6;
                return api_1.default.Groups.search(oldSearchText, oldLastItemMarker);

              case 6:
                _ref7 = _context4.sent;
                nextList = _ref7.list;
                last_item_marker = _ref7.last_item_marker;
                list = lodash_1.default.unionBy(lodash_1.default.concat(oldList, nextList), 'id');
                dispatch({
                  type: remote_groups_search_1.default.FETCH_MORE_SUCCESS,
                  list: list,
                  last_item_marker: !!last_item_marker ? last_item_marker : oldLastItemMarker
                });
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](3);
                dispatch({
                  type: remote_groups_search_1.default.FETCH_MORE_FAILURE,
                  error: _context4.t0
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 13]]);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}

exports.fetchMore = fetchMore;